import { createSvgIcon } from '@applift/factor'

export const GridColumnIcon = createSvgIcon(
  <path d="M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z" />,
  'ColumnIcon'
)

export const GridSeparatorIcon = createSvgIcon(
  <path d="M11 19V5h2v14z" />,
  'Separator'
)

export const GridFilterAltIcon = createSvgIcon(
  <path d="M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z" />,
  'FilterAlt'
)

export const GridArrowUpwardIcon = createSvgIcon(
  <>
    <path
      d="M12 5V19"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill="none"
    />
    <path
      d="M18 11L12 5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill="none"
    />
    <path
      d="M6 11L12 5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill="none"
    />
  </>,
  'ArrowUpward'
)

export const GridArrowDownwardIcon = createSvgIcon(
  <>
    <path
      d="M12 5V19"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill="none"
    />
    <path
      d="M18 13L12 19"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill="none"
    />
    <path
      d="M6 13L12 19"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill="none"
    />
  </>,
  'ArrowDownward'
)

export const GridUnsortedIcon = createSvgIcon(
  <>
    <path
      d="M9 9L12 6L15 9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill="none"
    />
    <path
      d="M15 15L12 18L9 15"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill="none"
    />
  </>,
  'GridUnsortedIcon'
)
